import { BOOL_FEATURE_FLAGS } from './FeatureFlagBool';
import { JSON_FEATURE_FLAGS } from './FeatureFlagJson';
import { NUMBER_FEATURE_FLAGS } from './FeatureFlagNumber';
import { STRING_FEATURE_FLAGS } from './FeatureFlagString';
import { useFeatureFlagBool } from './useFeatureFlagBool';

/**
 * Feature flag helpers.
 *
 * This functions wrap LaunchDarkly's API for more type-saftey and clean-up accountability.
 *
 * https://docs.launchdarkly.com/home/getting-started/feature-flags
 */

// keep-sorted:begin
export type {
  FeatureFlagOverride,
  FeatureFlagOverrideEntry,
  FeatureFlagOverrideFailure,
  FeatureFlagOverrideSource,
  FeatureFlagOverrideStore,
  FeatureFlagStoreParseFailure,
  FeatureFlagValueKind,
  ModernLoopFeatureFlagDevApi,
  SetFeatureFlagOverrideInput,
} from './override';
export type { FeatureFlagBool } from './FeatureFlagBool';
export type { FeatureFlagJson } from './FeatureFlagJson';
export type { FeatureFlagNames, LocalStorageFlags, RawFeatureFlagMap } from './useFeatureFlagLocal';
export type { FeatureFlagNumber } from './FeatureFlagNumber';
export type { FeatureFlagProviderProps } from './launchdarkly/FeatureFlagProvider';
export type { FeatureFlagString } from './FeatureFlagString';
export type { LDContext } from './launchdarkly/FeatureFlagProvider';
export {
  FEATURE_FLAG_OVERRIDE_STORAGE_KEY,
  clearFeatureFlagOverride,
  clearFeatureFlagOverrides,
  createFeatureFlagDevApi,
  installFeatureFlagDevApi,
  parseFeatureFlagOverrideStore,
  readFeatureFlagOverrideStore,
  resolveBooleanFeatureFlag,
  setFeatureFlagOverride,
  writeFeatureFlagOverrideStore,
} from './override';
export { BOOL_FEATURE_FLAGS } from './FeatureFlagBool';
export { FeatureFlagProvider } from './launchdarkly/FeatureFlagProvider';
export { JSON_FEATURE_FLAGS } from './FeatureFlagJson';
export { NUMBER_FEATURE_FLAGS } from './FeatureFlagNumber';
export { STRING_FEATURE_FLAGS } from './FeatureFlagString';
export { useEnforceAllowedLocale } from './useEnforceAllowedLocale';
export { useFeatureFlagBool, useFeatureFlagBoolList } from './useFeatureFlagBool';
export { useFeatureFlagJson } from './useFeatureFlagJson';
export { useFeatureFlagLocal } from './useFeatureFlagLocal';
export { useFeatureFlagNumber } from './useFeatureFlagNumber';
export { useFeatureFlagString } from './useFeatureFlagString';
export { useIdentifyFeatureFlagUser } from './launchdarkly/useIdentifyFeatureFlagUser';
export { useLocales, useSelectableLocales, useShowLanguageSelector, SupportedLocalesContext } from './useLocales';
// keep-sorted:end

export const useFlag = useFeatureFlagBool; // shorthand function

export const ALL_FEATURE_FLAGS = [
  ...BOOL_FEATURE_FLAGS,
  ...NUMBER_FEATURE_FLAGS,
  ...STRING_FEATURE_FLAGS,
  ...JSON_FEATURE_FLAGS,
];
